import { QueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { extractMessage } from "@/lib/errors";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      retry: 1,
    },
    mutations: {
      onError: (error) => {
        toast.error(extractMessage(error));
      },
    },
  },
});
